import { useTheme } from "@mui/material"
import { colors } from "../../../utils/theme"

/**
 * Shared Victory chart geometry + type for Treat charts.
 * Victory fontSize is in SVG user units — charts MUST share the same
 * width/height or the same fontSize renders at different pixel sizes.
 */
export const TREND_CHART = {
  width: 1272,
  height: 265,
  padding: { top: 36, bottom: 44, left: 98, right: 16 },
} as const

/** Light-mode defaults; dark mode overrides via `--vira-muted` / `--vira-ink`. */
export const chartAxisText = {
  fontFamily: "Lato",
  fill: `var(--vira-muted, ${colors.neutral.asphalt})`,
  fontSize: 10,
  fontWeight: 400 as const,
}

export const chartTickLabelStyle = {
  ...chartAxisText,
}

export const chartAxisLabelStyle = {
  ...chartAxisText,
  padding: 80,
}

export const chartTooltipText = {
  fontFamily: "Lato",
  fill: colors.neutral.white,
  fontSize: 11,
  fontWeight: 400 as const,
}

/**
 * Theme-aware Victory axis / tick styles — near-white fills in dark mode.
 */
export function useChartTypography() {
  const theme = useTheme()
  const isDark = theme.palette.mode === "dark"
  const fill = isDark
    ? theme.palette.vira?.muted ?? "#F0F3FA"
    : colors.neutral.asphalt

  const axisText = {
    fontFamily: "Lato",
    fill,
    fontSize: 10,
    fontWeight: 400 as const,
  }

  return {
    chartAxisText: axisText,
    chartTickLabelStyle: axisText,
    chartAxisLabelStyle: {
      ...axisText,
      padding: 80,
    },
    chartTooltipText: {
      fontFamily: "Lato",
      fill: isDark
        ? theme.palette.vira?.ink ?? "#FFFFFF"
        : colors.neutral.white,
      fontSize: 11,
      fontWeight: 400 as const,
    },
    gridStroke: isDark ? "rgba(255, 255, 255, 0.12)" : colors.neutral.clay,
    isDark,
  }
}
